// AWS Configuration for Smart Storage Application
export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'eu-west-2_v1g1tMCX0',
      userPoolClientId: '5g8r3rs5p5rut1fl6irl05fsrl',
      signUpVerificationMethod: 'code',
      loginWith: {
        email: true,
      },
    }
  },
  API: {
    REST: {
      'smart-storage-api': {
        endpoint: 'https://z9hnkb6rm3.execute-api.eu-west-2.amazonaws.com/prod',
        region: 'eu-west-2',
      }
    }
  }
};

export const API_CONFIG = {
  baseURL: 'https://z9hnkb6rm3.execute-api.eu-west-2.amazonaws.com/prod',
  region: 'eu-west-2',
};
